const tourSteps = [
  {
    id: "welcome",
    route: "/dashboard",
    target: "dashboard-setup",
    surface: "Dashboard",
    eyebrow: "Start here",
    title: "Start from your store overview",
    desc: "This header identifies the active store and marketplace, with a shortcut to product uploads.",
    hint: "Use Upload product to jump directly into catalog publishing.",
    placement: "left",
    cta: "Show setup",
  },
  {
    id: "setup",
    route: "/dashboard",
    target: "dashboard-overview",
    surface: "Dashboard",
    eyebrow: "Store summary",
    title: "Review your key totals",
    desc: "These cards summarize connected stores, eBay accounts, listed products, and imported orders.",
    hint: "Use these totals to quickly spot changes in your commerce workspace.",
    placement: "below",
    cta: "Review policies",
  },
  {
    id: "policies",
    route: "/dashboard",
    target: "dashboard-listing-health",
    surface: "Dashboard",
    eyebrow: "Marketplace",
    title: "Check listing health",
    desc: "Review listing coverage and status for each connected eBay account here.",
    hint: "Use Manage integrations if an account needs attention.",
    placement: "right",
    cta: "Next: templates",
  },
  {
    id: "templates",
    route: "/templates",
    target: "templates-create-action",
    surface: "Templates",
    expandProducts: true,
    eyebrow: "Step 2",
    title: "Create category templates",
    desc: "Use this action to create the reusable template layer that maps Wix product data into the right eBay category structure.",
    hint: "This should feel like the first real build action in the flow.",
    placement: "left",
    cta: "Next: profiles",
  },
  {
    id: "profiles",
    route: "/profiles",
    target: "profiles-create-action",
    surface: "Profiles",
    expandProducts: true,
    eyebrow: "Step 3",
    title: "Build listing profiles",
    desc: "Profiles combine templates, policies, and filters into the reusable publishing logic your products will follow.",
    hint: "This is where setup turns into an operating model.",
    placement: "left",
    cta: "Next: products",
  },
  {
    id: "products",
    route: "/products",
    target: "products-actions",
    surface: "Products",
    expandProducts: true,
    eyebrow: "Step 4",
    title: "Upload products to eBay",
    desc: "These actions are where importing, syncing, CSV work, and bulk eBay publishing actually happen.",
    hint: "This should be the most operational step in the walkthrough.",
    placement: "left",
    cta: "Track orders",
  },
  {
    id: "orders",
    route: "/orders",
    target: "orders-fetch-action",
    surface: "Orders",
    eyebrow: "After listing",
    title: "Manage eBay orders",
    desc: "Fetch and refresh eBay orders from here so the order view stays current when sales start coming in.",
    hint: "A tour step should show the action the user will actually click later.",
    placement: "left",
    cta: "Monitor activity",
  },
  {
    id: "activity",
    route: "/activity",
    target: "activity-running-card",
    surface: "Activity",
    eyebrow: "Operations",
    title: "Watch background jobs",
    desc: "This panel is where imports, uploads, and sync jobs expose their live progress while they are still running.",
    hint: "When a user asks 'is it done yet?', this is the answer.",
    placement: "below",
    cta: "Review plans",
  },
  {
    id: "plans",
    route: "/plans",
    target: "plans-billing-toggle",
    surface: "Plans",
    eyebrow: "Usage",
    title: "Compare plans before you scale",
    desc: "Switch billing cadence here and review the plan options before larger uploads or higher order volume.",
    hint: "This step should help users evaluate pricing, not just admire the page header.",
    placement: "below",
    cta: "Finish tour",
  },
];

export default tourSteps;
